import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { t } from "i18next";
import { formatIncompletePhoneNumber } from "libphonenumber-js";
import { ChangeEvent } from "react";
import { PhoneNumberModel } from "../store/features/estimateSlice";
import { InputLabel } from "@mui/material";

export default function PhoneNumber(props: {
  phone?: PhoneNumberModel;
  disabled?: boolean;
  placeholder?: string;
  errors?: any;
  label: string;
  updatePhone?: (phone: PhoneNumberModel) => void;
}) {
  return (
    <Box>
      <Grid container columnSpacing={3}>
        <Grid item xs={12}>
          <InputLabel
            htmlFor="standard-number"
            required
            variant="standard"
            shrink
            error={props.errors != null}
          >
            {props.label}
          </InputLabel>
          <TextField
            id="standard-number"
            size="small"
            required
            disabled={props.disabled}
            fullWidth
            type="text"
            placeholder={props.placeholder}
            value={props.phone?.number}
            error={props.errors != null}
            helperText={
              props.errors?.required != null
                ? t("callback.validations.requiredField")
                : props.errors?.invalidNumber != null
                ? t("callback.validations.invalidNumber")
                : ""
            }
            InputLabelProps={{
              shrink: true,
            }}
            variant="outlined"
            onChange={(
              event:
                | ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
                | undefined
            ) => {
              if (props.updatePhone != null) {
                const phone = event?.target.value;
                if (phone != null && props.phone?.prefix?.code != null) {
                  const formatedPhone = formatIncompletePhoneNumber(
                    phone,
                    props.phone.prefix.code
                  );

                  let newPhone: PhoneNumberModel = props.phone || {
                    prefix: undefined,
                    number: formatedPhone,
                  };

                  newPhone = { ...newPhone, number: formatedPhone };

                  props.updatePhone(newPhone);
                }
              }
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
